import L from "leaflet";

export const STATUS_CATS = [
  { key: "ativo", label: "Atendido · ação nos últimos 30 dias", color: "#10b981" },
  { key: "parado", label: "Atendido · sem ação recente", color: "#38bdf8" },
  { key: "prospecto", label: "Prospecto · aguardando infraestrutura", color: "#f59e0b" },
  { key: "sem_consultor", label: "Atendido · sem consultor", color: "#ef4444" },
];

const PALETTE = ["#3b82f6", "#10b981", "#f59e0b", "#ec4899", "#8b5cf6", "#14b8a6", "#f97316", "#84cc16", "#06b6d4", "#e11d48"];
export const NO_CONSULTOR_COLOR = "#64748b";

export const statusOf = (c) => {
  if (c.infra_status === "prospecto") return "prospecto";
  if (!(c.consultor || "").trim()) return "sem_consultor";
  return c.acoes_30d > 0 ? "ativo" : "parado";
};

export const slug = (s) => _norm(s).replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
const _norm = (s) => String(s || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

export const consultorColors = (names) =>
  Object.fromEntries([...names].sort().map((n, i) => [n, PALETTE[i % PALETTE.length]]));

const iconCache = {};
export const pinIcon = (color, approx) => {
  const k = `${color}-${approx}`;
  if (!iconCache[k]) {
    iconCache[k] = L.divIcon({
      className: "flua-pin",
      iconSize: [30, 40],
      iconAnchor: [15, 40],
      popupAnchor: [0, -36],
      html: `<svg width="30" height="40" viewBox="0 0 30 40" xmlns="http://www.w3.org/2000/svg">
        <path d="M15 1C7.3 1 1 7.2 1 14.9 1 25.4 15 39 15 39s14-13.6 14-24.1C29 7.2 22.7 1 15 1z" fill="${color}" stroke="#0b1220" stroke-width="2" ${approx ? 'stroke-dasharray="3 2" fill-opacity="0.75"' : ""}/>
        <circle cx="15" cy="15" r="5.5" fill="#fff"/>
      </svg>`,
    });
  }
  return iconCache[k];
};

export const isApprox = (precisao) => ["bairro", "cidade", "cep"].includes(precisao);

export const fmtDataBR = (iso) => (iso ? iso.split("-").reverse().join("/") : "—");
